import { RephraseActionKind } from './types';

const plainerWording: [RegExp, string][] = [
  [/\bobtain\b/gi, 'get'],
  [/\bassist\b/gi, 'help'],
  [/\bcommence\b/gi, 'start'],
  [/\bconclude\b/gi, 'end'],
  [/\bdemonstrate\b/gi, 'show'],
  [/\butilize\b/gi, 'use'],
  [/\bin order to\b/gi, 'to'],
  [/\bdue to the fact that\b/gi, 'because'],
];

export function mockRephrase(text: string, action: RephraseActionKind): string {
  const trimmed = text.trim();

  switch (action) {
    case 'improve_clarity': {
      let result = trimmed;
      plainerWording.forEach(([pattern, replacement]) => {
        result = result.replace(pattern, replacement);
      });
      return result.replace(/\s+/g, ' ');
    }
    case 'proofread': {
      const tidied = trimmed
        .replace(/\s+/g, ' ')
        .replace(/\s+([.,;:!?])/g, '$1')
        .replace(/([.,;:!?])(?=[^\s])/g, '$1 ');
      const capitalised = `${tidied.charAt(0).toUpperCase()}${tidied.slice(1)}`;
      return /[.!?]$/.test(capitalised) ? capitalised : `${capitalised}.`;
    }
  }
}
